<template>
  <div>
    <div class="tree-wrapper">
      <div id="tree" class="tree-container">
        <!-- <canvas id="canvasForTree"></canvas> -->
      </div>
    </div>
  </div>
</template>
<script>
import { apiMap } from "../utils/apiMap";
import { birthToDate, formatDeadKey } from "../utils/feed";
import dTree from "../utils/dTree";
import $ from "jquery";
import _ from "lodash";
export default {
  name: "clan-tree",
  data() {
    return {
      loadTree: true,
      boxWidth: 80,
      boxHeight: 30,
      fatherDivPad: 30,
      fatherDivWidth: 832,
      fatherDivHeight: 92,
      motherDivWidth: 832,
      motherDivHeight: 92,
      boxMargin: 11,
      mateScale: 15,
      husbandScale: 2,
      parentPosition: {},
    };
  },
  mounted() {
    // console.log(this.$router.app._route.query);
    // this.getFamilyTree();
    this.initTitle();
  },
  methods: {
    initTitle() {
      if (this.$router.app._route.query.type == "father") {
        document.title = `父系版本-${this.$router.app._route.query.id}`;
      } else {
        document.title = `母系版本-${this.$router.app._route.query.id}`;
      }
      let key = `${this.$router.app._route.query.type}-${this.$router.app._route.query.id}`;
      let treeData = localStorage.getItem(key);
      if (treeData) {
        this.initTreeWithD3(JSON.parse(treeData));
        // this.analysisFamilyTree(JSON.parse(treeData),1);
        // this.drawFamilyLine();
      } else {
        let tipMsg = `未从本地存储获取到 父系版本-${this.$router.app._route.query.id}`;
        this.$alert(tipMsg, {
          confirmButtonText: "确定",
          showClose: false,
          callback: (action) => {
            window.close();
          },
        });
      }
    },
    getFamilyTree() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      if (loginUser) {
        _this
          .$axios({
            baseURL: apiMap["commonUrl"],
            method: apiMap["fatherTree"]["method"],
            url: apiMap["fatherTree"]["url"],
            params: {
              token: loginUser.token,
              family: 1,
            },
          })
          .then(function (response) {
            if (response.data.result.statusCode == 1) {
              _this.treeData = response.data.result.data;
              // _this.ancestorNode = response.data.result.ancestors;
              _this.loadTree = false;
              _this.analysisFamilyTree(_this.treeData, 1);
              setTimeout(() => {
                _this.drawFamilyLine();
              }, 10);
            } else {
              _this.$message("您当前没有家谱");
            }
          })
          .catch(function (error) {
            console.log(error);
            if (error.message.includes("Network")) {
              window.location.reload();
            }
          });
      } else {
        window.location = "/login";
      }
    },
    analysisFamilyTree(data, generation) {
      let _this = this;
      var ancestorNode = document.getElementsByClassName("generation_1")[0];
      var userName = "";
      if (data.userName) {
        userName = data.userName == "null" ? "?" : data.userName;
      } else {
        userName = "?";
      }
      if (!ancestorNode) {
        var ancestorProfile = [];
        ancestorProfile[0] = $('<a class="child">' + userName + "</a>");
        ancestorProfile[0].attr({
          id: data.userId,
          sex: data.sex,
          status: data.status,
          birthday: data.birthday,
          title: userName == "?" ? "" : userName,
          "data-copy": data.copyFlag,
        });
        var newNode = $("<div>").attr({
          class: "child_box generation_1",
          generation: "1",
        });
        $(newNode).append(ancestorProfile).appendTo($("#tree"));
      }
      for (var p = 0; p < data.partners.length; p++) {
        var spouseName = "";
        if (data.partners[p].userName) {
          spouseName =
            data.partners[p].userName == "null"
              ? "?"
              : data.partners[p].userName;
        } else {
          spouseName = "?";
        }
        var spouseId = data.partners[p].userId;
        var status = data.partners[p].status;
        var spouseClass = "spouse " + data.userId;
        if (
          data.partnerPublicChildren[p] &&
          data.partnerPublicChildren[p].length > 0
        ) {
          spouseClass = "spouse hasChild " + data.userId;
        }
        var sureSpouse = $(
          '<a class="' + spouseClass + '">' + spouseName + "</a>"
        );
        sureSpouse.attr({
          id: spouseId,
          sex: data.partners[p].sex,
          mate: data.userId,
          status: status,
          title: spouseName == "?" ? "" : spouseName,
        });
        _this.createOneGeneContainer(sureSpouse, generation);
      }

      generation++;
      if (data.partnerPublicChildren.length !== 0) {
        for (var i = 0; i < data.partnerPublicChildren.length; i++) {
          var sureChildMother = data.partners[i].userId;
          var orderedChildren = _this.descSortChildrenInAll(
            data.partnerPublicChildren[i]
          );
          for (var j = 0; j < orderedChildren.length; j++) {
            if (orderedChildren[j]) {
              var sureChildName = "";
              if (orderedChildren[j] && orderedChildren[j].userName) {
                sureChildName =
                  orderedChildren[j].userName == "null"
                    ? "?"
                    : orderedChildren[j].userName;
              } else {
                sureChildName = "?";
              }
              var sureChild = $(
                '<a class="child ' +
                  sureChildMother +
                  '">' +
                  sureChildName +
                  "</a>"
              );
              sureChild.attr({
                id: orderedChildren[j].userId,
                father: data.userId,
                mother: sureChildMother,
                sex: orderedChildren[j].sex,
                status: orderedChildren[j].status,
                birthday: orderedChildren[j].birthday,
                title: sureChildName == "?" ? "" : sureChildName,
                "data-copy": orderedChildren[j].copyFlag,
              });
              _this.createOneGeneContainer(sureChild, generation);
              _this.analysisFamilyTree(orderedChildren[j], generation);
            }
          }
        }
      }
      _this.arrangeAllChild();
    },
    createOneGeneContainer(node, generation) {
      var nodeContainer = document.getElementsByClassName(
        "generation_" + generation
      )[0];
      if (nodeContainer) {
        $(nodeContainer).append(node).appendTo($("#tree"));
      } else {
        var newContainer = $("<div>").attr({
          class: "child_box generation_" + generation,
          generation: generation,
        });
        $(newContainer).append(node).appendTo($("#tree"));
      }
    },
    //兄弟排序
    descSortChildrenInAll(jsonObj) {
      var newArray = new Array();
      var tempJson = {};
      if (jsonObj.length > 1) {
        var birthArr = new Array();
        var birthIdArr = [];
        var nonBirthPerson = [];
        // var regExp = /^[0-9.-]+$/;
        var regExp = /^[\-|0-9][0-9]*/;
        for (let i = 0; i < jsonObj.length; i++) {
          //将有生日的节点的生日和ID保存在生日数组中
          if (regExp.test(jsonObj[i].birthday) && jsonObj[i].birthday != "0") {
            var birthKey = "";
            if (jsonObj[i].status == 0) {
              birthKey = birthToDate(jsonObj[i].birthday);
            } else if (jsonObj[i].status == 2) {
              birthKey = formatDeadKey(jsonObj[i].birthday);
            }
            birthArr.push({
              birthday: birthKey,
              userId: jsonObj[i].userId,
            });
          } else {
            nonBirthPerson.push(jsonObj[i]);
          }
          var userId = jsonObj[i].userId;

          //将所有节点放在临时对象中
          tempJson[userId] = {
            userId: jsonObj[i].userId,
            sex: jsonObj[i].sex,
            addTime: jsonObj[i].addTime,
            userName: jsonObj[i].userName,
            birthday: jsonObj[i].birthday,
            partnerPublicChildren: jsonObj[i].partnerPublicChildren,
            partners: jsonObj[i].partners,
            status: jsonObj[i].status,
          };
        }

        //对有生日的节点排序，取得对应的ID
        if (birthArr.length > 0) {
          var sortBirth = _.sortBy(birthArr, ["birthday"]);
          birthIdArr = Array.from(sortBirth.map((d) => d["userId"]));
        }

        if (birthIdArr.length > 0) {
          for (let x = 0; x < birthIdArr.length; x++) {
            var mixtureKey = birthIdArr[x];
            if (tempJson[mixtureKey]) {
              newArray[x] = tempJson[mixtureKey];
            }
          }
        }

        if (nonBirthPerson.length != 0) {
          for (let m = 0; m < nonBirthPerson.length; m++) {
            var findArr = newArray.filter(
              (item) => item.userId === nonBirthPerson[m].userId
            );
            if (findArr.length == 0) {
              newArray.push(nonBirthPerson[m]);
            }
          }
        }
      } else {
        newArray = jsonObj;
      }
      return newArray;
    },
    arrangeAllChild() {
      var divBinJQ = $("#tree");
      var divJQ = $(">div.child_box", divBinJQ);
      var EntityList = [];
      divJQ.each(function () {
        var thisJQ = $(this);
        EntityList.push({
          generation: parseInt(thisJQ.attr("generation"), 10),
          JQ: thisJQ,
        });
      });
      EntityList.sort(function (a, b) {
        return a.generation - b.generation;
      });
      for (var i = 0; i < EntityList.length; i++) {
        EntityList[i].JQ.appendTo(divBinJQ);
      }
    },
    //初始化画布
    initCanvasContext() {
      let _this = this;
      var generationPerson = new Array();
      $("#tree")
        .find(".child_box")
        .each(function () {
          var oneGeneration = $(this).find("a").length;
          generationPerson.push(oneGeneration);
        });
      // var maxUser = sortArray(generationPerson,"max");
      // var maxGeneration = sortArray(generationArr,"max");
      // _.sortedUniq([1, 1, 2]);
      generationPerson = Array.from(new Set(generationPerson));
      generationPerson.sort(function (a, b) {
        return a - b;
      });
      // var maxUser = generationPerson.pop();
      // var maxGeneration = $("#tree").find(".child_box").length;
      // var canvas = document.getElementById("canvasForTree");
      // var ctx = canvas.getContext("2d");
      // var basicWidth = _this.boxWidth+2*_this.boxMargin+2;
      // canvas.width = 832;
      // if (maxUser*basicWidth>832) {
      //     _this.fatherDivWidth = maxUser*basicWidth;
      //     $("#tree").find(".child_box").css("width",_this.fatherDivWidth+"px");
      //     canvas.width = _this.fatherDivWidth;
      // }
      // canvas.height = maxGeneration*_this.fatherDivHeight;
      // return ctx;

      var maxUser = generationPerson.pop();
      var maxGeneration = $("#tree").find(".child_box").length;
      var canvas = document.getElementById("canvasForTree");
      var ctx = canvas.getContext("2d");
      var minWidth = $("#tree").width();
      if ($("#tree").find(".child_box").length == 1) {
        minWidth = $("#tree")[0].offsetWidth;
      }
      var basicWidth = _this.boxWidth + 2 * _this.boxMargin + 2;
      var maxWidth = maxUser * basicWidth;
      // var maxWidth = maxUser*107;
      if (maxWidth > minWidth) {
        minWidth = maxWidth;
        $("#tree")
          .find(".child_box")
          .css("width", minWidth + "px");
      }
      _this.fatherDivWidth = minWidth;
      canvas.width = minWidth;
      canvas.height = maxGeneration * _this.fatherDivHeight;
      return ctx;
    },
    drawFamilyLine() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      var ctx = _this.initCanvasContext();
      ctx.strokeStyle = "#000000";
      $(".child_box")
        .find(".child")
        .each(function () {
          //var Mother = this.classList[1];
          var main = $(this);
          // var sex = main.attr("sex");
          var key = main.attr("id");
          var motherId = main.attr("mother");

          var positionWithMon = "";
          if (motherId) {
            if (main[0].offsetLeft - $("#" + motherId)[0].offsetLeft < 0) {
              positionWithMon = "left";
            } else {
              positionWithMon = "right";
            }
          }

          if (loginUser.userId.toString() == key) {
            main.addClass("is_me");
          }
          var generation = parseInt($(this).parent().attr("generation"));

          var brotherNodes = main.parents(".generation_" + generation).find("a")
            .length;

          var prevNodes = main.prevAll("a").length;
          var Partners = main
            .parent()
            .find(".spouse")
            .filter("." + key);
          var sumMargin =
            [brotherNodes - (2 * prevNodes + 1)] * _this.boxMargin; //总间距
          var sumWidth =
            ([brotherNodes - (2 * prevNodes + 2)] / 2) * _this.boxWidth; //总宽度

          var mainAbscissa = _this.fatherDivWidth / 2 - sumMargin - sumWidth; //配偶横坐标
          var mainOrdinate = (generation - 0.5) * _this.fatherDivHeight; //配偶纵坐标
          // 配偶基准坐标
          var matePosition = {
            x: mainAbscissa + _this.boxMargin,
            y: mainOrdinate,
          };
          var hasChildSpouse = main.parent().find(".hasChild");
          for (var s = 0; s < Partners.length; s++) {
            var curPartnerPrevNodes = $(Partners[s]).prevAll("a").length;
            //var husbandId = $(Partners[s]).attr("mate");
            var mateId = $(Partners[s]).attr("id");
            var Children = $(Partners[s])
              .parent()
              .next("div")
              .find(".child")
              .filter("." + mateId);
            //console.log($(Children[0]));  //可判断相对位置
            var curPartnerMargin =
              [brotherNodes - (2 * curPartnerPrevNodes + 1)] * _this.boxMargin; //总间距
            var curPartnerWidth =
              ([brotherNodes - (2 * curPartnerPrevNodes + 2)] / 2) *
              _this.boxWidth; //总宽度
            var curPartnerAbscissa =
              _this.fatherDivWidth / 2 -
              curPartnerMargin -
              curPartnerWidth -
              _this.boxWidth; //第s任妻子横坐标
            var childPosition = "";
            // var nextNodes = 0;
            // var childPrevNodes = 0;
            var matePrevNodes = 0;
            var mateNextNodes = 0;
            var mateIndex = 0;
            if (Children[0]) {
              // console.log(main.text());
              // console.log($(Partners[s])[0].offsetLeft);
              // console.log($(Children[0])[0].offsetLeft);
              if (
                $(Children[0])[0].offsetLeft - $(Partners[s])[0].offsetLeft <
                0
              ) {
                childPosition = "left";
              } else {
                childPosition = "right";
              }
              matePrevNodes = $(Partners[s]).prevAll("a").length;
              mateNextNodes = $(Partners[s]).nextAll("a").length;
              for (let i = 0; i < hasChildSpouse.length; i++) {
                if ($(hasChildSpouse[i]).attr("id") == mateId) {
                  mateIndex = i + 1;
                }
              }
              // nextNodes = $(Children[0]).nextAll("a").length;
              // childPrevNodes = $(Children[0]).prevAll("a").length;
            }
            var curPartnerOrdinate = (generation - 0.5) * _this.fatherDivHeight; //第s任妻子纵坐标
            var parentPositionY = 0;
            if (hasChildSpouse.length > 1) {
              if (childPosition == "left") {
                parentPositionY =
                  20 +
                  2 * mateIndex +
                  2 * matePrevNodes +
                  hasChildSpouse.length;
              } else if (childPosition == "right") {
                parentPositionY =
                  20 +
                  2 * mateIndex -
                  2 * mateNextNodes -
                  hasChildSpouse.length;
              }
            } else {
              parentPositionY =
                _this.motherDivHeight / 2 - prevNodes * _this.husbandScale;
            }

            if (parentPositionY < 19) {
              if (childPosition == "left") {
                parentPositionY =
                  20 +
                  2 * mateIndex +
                  2 * matePrevNodes +
                  hasChildSpouse.length;
              } else if (childPosition == "right") {
                parentPositionY =
                  20 +
                  3 * mateIndex +
                  2 * mateNextNodes +
                  hasChildSpouse.length -
                  matePrevNodes;
              }
            }
            if (parentPositionY > 55) {
              parentPositionY = 55;
            }
            _this.parentPosition[mateId] = {
              x: curPartnerAbscissa - _this.boxMargin,
              y: curPartnerOrdinate + parentPositionY,
            };

            // 配偶基准坐标
            var curPartnerPosition = {
              x: curPartnerAbscissa - _this.boxMargin,
              y: curPartnerOrdinate,
            };

            //第s任配偶连接配偶横线
            ctx.beginPath();
            ctx.moveTo(curPartnerAbscissa, curPartnerOrdinate);
            ctx.lineTo(curPartnerPosition.x, curPartnerPosition.y);
            ctx.stroke();
            ctx.closePath();

            if (Children.length != 0) {
              //第s任配偶连接子代竖线
              ctx.beginPath();
              ctx.moveTo(curPartnerPosition.x, curPartnerPosition.y);
              ctx.lineTo(
                curPartnerPosition.x,
                curPartnerOrdinate + parentPositionY
              );
              ctx.stroke();
              ctx.closePath();
            }

            //配偶数大于1
            if (s != 0) {
              //配偶向上竖线(第一任妻子)
              if (Children[1]) {
                ctx.beginPath();
                ctx.moveTo(matePosition.x - 5, matePosition.y);
                ctx.lineTo(
                  matePosition.x - 5,
                  matePosition.y - _this.boxHeight
                );
                ctx.stroke();
                ctx.closePath();
              } else {
                ctx.beginPath();
                ctx.moveTo(matePosition.x, matePosition.y);
                ctx.lineTo(matePosition.x, matePosition.y - _this.boxHeight);
                ctx.stroke();
                ctx.closePath();
              }

              //配偶向上竖线(非第一任妻子)
              ctx.beginPath();
              ctx.moveTo(curPartnerPosition.x, curPartnerPosition.y);
              ctx.lineTo(
                curPartnerPosition.x,
                curPartnerPosition.y - _this.boxHeight
              );
              ctx.stroke();
              ctx.closePath();

              //配偶连接配偶横线
              ctx.beginPath();
              ctx.moveTo(matePosition.x, matePosition.y - _this.boxHeight);
              ctx.lineTo(
                curPartnerPosition.x,
                curPartnerPosition.y - _this.boxHeight
              );
              ctx.stroke();
              ctx.closePath();
            }
          }

          if (Partners.length != 0) {
            //配偶横线
            var curPartnerX = mainAbscissa;
            ctx.beginPath();
            ctx.moveTo(curPartnerX, mainOrdinate);
            ctx.lineTo(matePosition.x, matePosition.y);
            ctx.stroke();
            ctx.closePath();
          }

          var aimPosition = _this.parentPosition[motherId];

          if (aimPosition) {
            var childBasicX = mainAbscissa - _this.boxWidth / 2;
            if (positionWithMon == "left") {
              childBasicX = childBasicX + 5;
            } else if (positionWithMon == "right") {
              childBasicX = childBasicX - 5;
            }

            var childBasicPosition = {
              x: childBasicX,
              y: mainOrdinate - _this.boxHeight / 2,
            };

            var difference = childBasicPosition.y - aimPosition.y;
            if (difference != _this.fatherDivPad) {
              var supplement = difference - _this.fatherDivPad;
              //子代向上竖线 (同父异母)
              ctx.beginPath();
              ctx.moveTo(
                childBasicPosition.x,
                childBasicPosition.y - _this.fatherDivHeight / 3 - supplement
              );
              ctx.lineTo(childBasicPosition.x, childBasicPosition.y);
              ctx.stroke();
              ctx.closePath();

              //子代与父母横线
              ctx.beginPath();
              ctx.moveTo(
                childBasicPosition.x,
                childBasicPosition.y - _this.fatherDivHeight / 3 - supplement
              );
              ctx.lineTo(aimPosition.x, aimPosition.y);
              ctx.stroke();
              ctx.closePath();
            } else {
              //子代向上竖线 (同父同母)
              ctx.beginPath();
              ctx.moveTo(
                childBasicPosition.x,
                childBasicPosition.y - _this.fatherDivHeight / 3
              );
              ctx.lineTo(childBasicPosition.x, childBasicPosition.y);
              ctx.stroke();
              ctx.closePath();

              //子代与父母横线
              ctx.beginPath();
              ctx.moveTo(
                childBasicPosition.x,
                childBasicPosition.y - _this.fatherDivHeight / 3
              );
              ctx.lineTo(aimPosition.x, aimPosition.y);
              ctx.stroke();
              ctx.closePath();
            }
          }
        });
    },
    initTreeWithD3(treeData) {
      let _this = this;
      dTree.init(treeData, {
        target: "#tree",
        debug: true,
        hideMarriageNodes: true,
        marriageNodeSize: 5,
        height: 800,
        width: 1200,
        callbacks: {
          nodeClick: function (name, userId) {
            // alert('左击: ' + name);
          },
          // nodeRightClick: function(name, extra) {
          // 	alert('右击: ' + name);
          // },
          textRenderer: function (name, userId, extra, textClass) {
            if (extra && extra.nickname)
              name = name + " (" + extra.nickname + ")";
            return (
              "<p align='center' class='" +
              textClass +
              "' title='" +
              userId +
              "'>" +
              name +
              "</p>"
            );
          },
          marriageClick: function (extra, id) {
            alert("Clicked marriage node" + id);
          },
          marriageRightClick: function (extra, id) {
            alert("Right-clicked marriage node" + id);
          },
        },
      });
    },
  },
};
</script>
<style>
.tree-wrapper {
  min-height: 60px;
  background-color: #fff;
}

.tree-container {
  position: relative;
  min-width: 514px;
  height: auto;
  margin: 0 auto;
  overflow: auto;
  text-align: center;
}

#canvasForTree {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}

.tree-container .child_box {
  width: inherit;
  position: relative;
  height: 32px;
  padding: 30px 0;
  margin: 0 auto;
  white-space: nowrap;
  z-index: 3;
}

.tree-container div a {
  display: inline-block;
  width: 80px;
  height: 30px;
  margin: 0 10px;
  font-size: 14px;
  border: 1px solid #000000;
  border-radius: 5px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 30px;
  color: #333333;
}

.tree-container div a.is_me {
  color: #fb6161;
}

.linage {
  fill: none;
  stroke: #000;
}
.marriage {
  fill: none;
  stroke: black;
}
.marriageNode {
  background-color: black;
  border-radius: 50%;
}
.man {
  line-height: 20px;
  background-color: #fff;
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
  border-radius: 4px;
}
.woman {
  line-height: 20px;
  background-color: #fff;
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
  border-radius: 4px;
}

svg.tree-svg {
  border-style: solid;
  border-width: 1px;
  border-color: #cccccc;
}

.is-me {
  color: #fb6161;
  border-color: #000;
}
</style>